import React from 'react';
import s from './EnumCard.scss';
import { LinkWrapper } from '../../../components/BaseComp';
import { isFeedInstance, FeedInstance } from '../../../models/feed';
import { PromotionInstance } from '../../../models/apis/promotion';
import { EnumLoadingCard } from './Loading';

export interface EnumConfig {
    source: Array<Array<FeedInstance | PromotionInstance>>,
    titles: string[],
    spm: string,
}

export const EnumCard = (props: EnumConfig) => {
    const { source, titles, spm } = props;
    const willShowLoading = typeof window !== 'undefined' && !source.reduce((a, b) => a + b.length, 0);
    return (
        <div className={s.cardContainer} style={{height: 192}} >
            {
                !willShowLoading
                ? source.map((arr, index) => {
                const key = titles[index];
                return (
                    <div key={index} className={s.item} data-spm={`${spm}-news${index + 2}`}>
                        { arr.length ? <pre>{key.length > 3 ? `${key.slice(0, 2)}\n${key.slice(2)}` : key}</pre> : null }
                        <ul>
                            {
                                arr.map((item, i) => isFeedInstance(item) ? (
                                    <li key={item.title + i}>
                                        <LinkWrapper href={item.url}>{item.title}</LinkWrapper>
                                    </li>
                                ) : null)
                            }
                        </ul>
                    </div>
                );
            })
            : willShowLoading ? <EnumLoadingCard /> : null
        }
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/HomeTop/EnumCard/index.tsx